import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { initLenis, getLenis } from "./lib/scroll";
import Preloader from "./components/Preloader";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Landing from "./pages/Landing";
import ProductPage from "./pages/ProductPage";
import AccountPage from "./pages/AccountPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [loading, setLoading] = useState(
    () => !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
  const [ready, setReady] = useState(false);

  useEffect(() => {
    initLenis();
  }, []);

  useEffect(() => {
    if (!loading) return;
    const t = setTimeout(() => setLoading(false), 2100);
    return () => clearTimeout(t);
  }, [loading]);

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="relative bg-[#F8F5F2] text-ink min-h-screen">
            <div className="grain-fixed" aria-hidden />

            <AnimatePresence>
              {loading && <Preloader onDone={() => setReady(true)} />}
            </AnimatePresence>

            <Nav ready={ready || !loading} />

            <main>
              <Routes>
                <Route path="/" element={<Landing ready={ready || !loading} />} />
                <Route path="/products/luxe-hydrating-cream" element={<ProductPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>

            <Footer />
            <CartDrawer />
            <Toaster
              position="top-center"
              toastOptions={{
                style: {
                  background: "#171310",
                  color: "#F8F5F2",
                  borderRadius: "999px",
                  fontFamily: "Jost, sans-serif",
                  fontSize: "13px",
                },
              }}
            />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
